<div class="statistic-container fx-layout-column fx-fill-height">
	<div
		class="fx-layout-row-nowrap fx-content-start fx-items-stretch fx-gap-4 fx-grow-1 statistic-inner-container">
		<div class="fx-grow-1 fx-fill-height fx-overflow-auto">
			<router-outlet></router-outlet>
		</div>
	</div>
</div>
